// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@media only screen {
  .id-bg-image, .vehicle-img.xslider-s {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
  }
  .id-bg-image.black, .vehicle-img.xslider-s.black {
    border-bottom: none;
    border-radius: 6px 6px 0 0;
  }
  .image-displayer-loading {
    vertical-align: middle;
    text-align: center;
    display: flex;
    height: 96px;
  }
  .vehicle-text {
    background: var(--ion-color-secondary);
    height: 40px;
    top: unset;
    bottom: -20px;
    border-radius: 0 0 6px 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/image-displayer/image-displayer.component.scss"],"names":[],"mappings":"AAEA;EACI;IACI,UAAA;EADN;EAIE;IACI,UAAA;EAFN;AACF;AAKA;EACI;IACI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;EAHN;EAMM;IACI,mBAAA;IACA,0BAAA;EAJV;EAOE;IACI,sBAAA;IAAwB,kBAAA;IAAoB,aAAA;IAAc,YAAA;EAFhE;EAaE;IACI,sCAAA;IACA,YAAA;IACA,UAAA;IACA,aAAA;IACA,0BAAA;EAXN;AACF","sourcesContent":["\r\n\r\n@keyframes lds-spinner {\r\n    0% {\r\n        opacity: 1;\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@media only screen {\r\n    .id-bg-image, .vehicle-img.xslider-s {\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        z-index: 1;\r\n        // border: 1px solid var(--ion-color-medium-tint);\r\n        // border: 1px solid var(--ion-color-lighter-contrast);\r\n        &.black {\r\n            border-bottom: none;\r\n            border-radius: 6px 6px 0 0;\r\n        }   \r\n    }\r\n    .image-displayer-loading {\r\n        vertical-align: middle; text-align: center; display:flex; height: 96px;\r\n    }\r\n\r\n    // .id-image {\r\n    //     margin: 0 auto;\r\n    //     max-height: 275px;\r\n    //     @media only screen and (min-width: 640px) {\r\n    //         max-height: 500px; \r\n    //     }\r\n    // }\r\n    \r\n    .vehicle-text {\r\n        background: var(--ion-color-secondary); \r\n        height: 40px;\r\n        top: unset;\r\n        bottom: -20px;\r\n        border-radius: 0 0 6px 6px;\r\n    }\r\n\r\n}\r\n\r\n// .image-displayer {\r\n// \tborder: 1px solid rgba(0,0,0,0.1);\r\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
